<template>
  <b-modal
    :hide-footer="true"
    :title="$t('Cadastrar não cumprimento')"
    centered
    size="xl"
    id="cadastrar-descumprimento-educacao"
  >
    <form @submit.prevent="submit" ref="addItem">
      <div class="row">
        <form-select
          v-model="pessoa"
          label="Pessoa"
          :itens="pessoas"
          :required="true"
        />
        <form-calendar
          v-model="dataAdd"
          grid="4"
          label="Data da ocorrência"
          :required="true"
          :max-date="dataAdd"
        />
        <form-select
          v-model="efeito"
          grid="4"
          label="Efeito do não cumprimento"
          :itens="$root.arrays.efeito_descumprimento"
          :required="true"
        />
        <form-select
          v-model="solicitada_suspensao"
          grid="4"
          label="Solicitada suspensão do efeito?"
          :itens="$root.arrays.pergunta"
        />

        <form-textarea
          v-model="observacao"
          placeholder="Digite aqui..."
          grid="12"
          rows="3"
          max-rows="6"
          label="Observação"
        />
      </div>

      <div class="row pt-4 px-2 d-flex justify-content-end">
        <button
          @click="submit"
          class="btn btn-success btn-add-descumprimento"
          data-style="zoom-in"
        >
          <i class="mdi mdi-content-save"></i>
          Salvar
        </button>
      </div>
    </form>
  </b-modal>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      pessoa: "",
      efeito: "",
      dataAdd: moment().format("YYYY/MM/DD"),
      solicitada_suspensao: "",
      observacao: "",
    };
  },
  computed: {
    pessoas() {
      const pessoas = this.item.familiares;

      const map = pessoas.map((elem) => ({
        id: elem.id,
        searchTerms: [elem?.nome_completo, elem?.nome_social],
        value: elem.nome_completo + " <b>" + elem.idade + " ano(s)</b>",
      }));
      return map;
    },
  },
  methods: {
    submit() {
      let ladda = Ladda.create(
        document.querySelector(".btn-add-descumprimento")
      );
      ladda.start();
      this.data_ocorrencia = this.$options.filters.formatDateYMD(this.dataAdd);
      axios
        .post("api/dashboard/familias/descumprimento", {
          usuario_id: this.pessoa,
          familia_id: this.item.id,
          efeito: this.efeito,
          data_ocorrencia: this.data_ocorrencia,
          solicitada_suspensao: this.solicitada_suspensao,
          observacao: this.observacao,
          tipo: "educacao",
        })
        .then((response) => {
          this.$snack.success({
            button: false,
            text: "Não cumprimento cadastrado com sucesso.",
          });
          this.item.descumprimentos = response.data;
          this.$bvModal.hide("cadastrar-descumprimento-educacao");

          this.pessoa = "";
          this.efeito = "";
          this.data_ocorrencia = "";
          ladda.stop();
        });
    },
  },
};
</script>
